<template>
  <div class="recommend-list">
    <div class="recommend">
      <!-- 标题开始 -->
      <div class="title">
        <div class="title-main">
          <div class="title-main-public">
            <div class="title-main-public-1 line-margin-1"></div>
            <div class="title-main-public-2"></div>
            <div class="title-main-public-3 line-margin-2"></div>
          </div>
          <div class="title-main-text">为您推荐</div>
          <div class="title-main-public title-main-public-2">
            <div class="title-main-public-1"></div>
            <div class="title-main-public-2"></div>
            <div class="title-main-public-3"></div>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="list" v-for="(item, index) in recommendData" :key="index">
          <div @click="recommendClick(item)">
            <div class="img">
              <el-image
                style="width: 160px; height: 150px"
                :src="item.skuDetailUrl"
                :fit="'cover'"
              >
              </el-image>
            </div>
            <div class="text">
              {{ item.skuName }}
            </div>
            <div class="price">
              ￥<span class="price-item">{{ item.salePrice }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getSkuRecommendList } from "@/app/shop/api/shopping";
export default {
  name: "recommendList",
  data() {
    return {
      recommendData: [],
      options: [],
      value: "",
      baseUrl: this.$addUrlPerFix(process.env.VUE_APP_BASE_URL)
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      getSkuRecommendList({
        agentIdEMP: "100013",
        isShowPageLoading: true
      }).then(res => {
        if (res.data.code === "0") {
          this.recommendData = res.data.data.skuRecommendDetailBOS;
        }
      });
    },
    getItem(item) {
      queryFriendshipAddressItemPage({
        friendshipAddressId: item.friendshipAddressId
      }).then(res => {
        if (res.data.code === "0") {
          item.options = res.data.data.rows;
        }
      });
    },
    recommendClick(item) {
      console.log(this.baseUrl, "baseUrl");
      let href = "";
      if (this.baseUrl.indexOf("dev01") != -1) {
        href = `http://dev01-emi.iccec.cn/${item.skuId}`;
      } else if (this.baseUrl.indexOf("test01") != -1) {
        href = `http://test01-emi.iccec.cn/${item.skuId}`;
      } else if (this.baseUrl.indexOf("uat01") != -1) {
        href = `http://uat01-emi.iccec.cn/${item.skuId}`;
      } else {
        href = `http://emi.iccec.cn/${item.skuId}`;
      }
      window.open(href, "_blank");
    },
    change(data) {
      window.open(data.friendshipAddressItemUrl, "_blank");
    }
  }
};
</script>
<style scoped lang="scss">
.recommend-list {
  width: 1180px;
  height: 592px;
  margin-top: 20px;
  .recommend {
    // overflow: hidden;
    .title .title-main .title-main-public .line-margin-1 {
      margin-left: 20px;
    }
    .title .title-main .title-main-public .line-margin-2 {
      margin-left: 10px;
    }
    .title-main {
      display: flex;
      justify-content: center;
    }
    .title-main-text {
      font-weight: 600;
      font-size: 24px;
      color: #4a4a4a;
      line-height: 24px;
      text-align: center;
      margin-left: 10px;
    }
    .title .title-main .title-main-public {
      padding: 2px 0;
      float: left;
    }
    .title .title-main .title-main-public-2 {
      margin-right: 0;
      margin-left: 10px;
    }
    .title .title-main .title-main-public .title-main-public-1 {
      width: 10px;
      height: 2px;
      background: #b2b2b2;
      border-radius: 2px;
    }
    .title .title-main .title-main-public .title-main-public-2 {
      width: 30px;
      height: 2px;
      background: #b2b2b2;
      border-radius: 2px;
      margin: 6px 0;
    }
    .title .title-main .title-main-public .title-main-public-3 {
      width: 20px;
      height: 2px;
      background: #b2b2b2;
      border-radius: 2px;
    }
    .content {
      display: flex;
      flex-wrap: wrap;
      .list {
        width: 198px;
        height: 230px;
        background: #ffffff;
        margin-right: 10px;
        margin-top: 20px;
        padding: 15px;
        &:nth-of-type(5) {
          margin-right: 0px;
        }
        &:nth-of-type(10) {
          margin-right: 0px;
        }
        .img {
          text-align: center;
          margin-bottom: 14px;
        }
        .text {
          font-weight: 400;
          height: 36px;
          font-size: 13px;
          color: #666666;
          line-height: 18px;
          text-align: left;
          margin-bottom: 10px;
          display: -webkit-box;
          text-overflow: ellipsis;
          overflow: hidden;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .price {
          font-weight: 600;
          font-size: 12px;
          color: #f51530;
          line-height: 17px;
          text-align: left;
          .price-item {
            font-size: 16px;
          }
        }
        &:hover {
          transform: translate3d(0, -3px, 0);
          box-shadow: 0 1px 4px rgba(0, 0, 0, 0.27);
        }
      }
    }
  }
}
</style>
